(($, Drupal) => {
    Drupal.behaviors.gallery = {
        attach: function attach() {
            $(".gallery").once("gallery").each(function() {
                const images = $(this).find("img");
                images.on("click", function() {
                    const imageWrapper = $("<div>", { class: "slider" });
                    images.each((index, item) => {
                        
                        const imageUrl = $(item).prop("src");
                
                        const image = $("<img>", { src: imageUrl, class: "gallery__overlay-image" })
                            .on("click", function(e) { 
                                e.stopPropagation(); });
                        imageWrapper.append(image)
                    })

                    const overlay = $("<div>", { class: "gallery__overlay overlay__slider" })
                        .on("click", function() { 
                            $("body").removeClass("hide-scroll"); 
                            $(this).remove(); })
                        .append(imageWrapper);
                    $("body").addClass("hide-scroll").prepend(overlay);
                    sliderInit(imageWrapper[0]);
                    const thisImage = this;
                    images.each((index, item) => {
                        if($(item).is(thisImage))
                        {
                            imageWrapper.trigger("to.owl.carousel", [index, 0])
                        }
                    })
                    
                })

            });
        }
    };

})(jQuery, Drupal);
  